"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var XlsIcon = function XlsIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "icon/xls"), /*#__PURE__*/React.createElement("g", {
    id: "OCR",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/xls"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-3",
    transform: "translate(2.500000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,15 C15,15.5522847 14.5522847,16 14,16 L2,16 C1.44771525,16 1,15.5522847 1,15 L1,1 C1,0.44771525 1.44771525,1.01453063e-16 2,0 L11,0 L15,4 L15,15 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#E8FAF3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#20D489",
    x: "0",
    y: "8",
    width: "13",
    height: "6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74,13 L3.66,11.62 L4.58,13 L5.295,13 L4.01,11.155 L5.215,9.43 L4.5,9.43 L3.66,10.69 L2.82,9.43 L2.105,9.43 L3.3,11.155 L2.025,13 L2.74,13 Z M8.18,13 L8.18,12.5 L6.25,12.5 L6.25,9.43 L5.67,9.43 L5.67,13 L8.18,13 Z M9.95,13.07 C10.405,13.07 10.76,12.975 11.01,12.795 C11.26,12.61 11.385,12.355 11.385,12.035 C11.385,11.705 11.23,11.45 10.92,11.265 C10.78,11.185 10.47,11.065 9.985,10.915 C9.655,10.81 9.45,10.735 9.375,10.695 C9.205,10.605 9.125,10.48 9.125,10.33 C9.125,10.16 9.195,10.035 9.345,9.96 C9.465,9.895 9.635,9.865 9.86,9.865 C10.12,9.865 10.32,9.91 10.45,10.01 C10.58,10.105 10.675,10.265 10.725,10.485 L11.305,10.485 C11.27,10.095 11.125,9.805 10.875,9.62 C10.64,9.445 10.31,9.36 9.89,9.36 C9.505,9.36 9.19,9.445 8.94,9.62 C8.67,9.8 8.54,10.05 8.54,10.365 C8.54,10.68 8.675,10.92 8.95,11.085 C9.055,11.145 9.33,11.245 9.77,11.385 C10.165,11.505 10.395,11.585 10.465,11.62 C10.685,11.73 10.8,11.88 10.8,12.07 C10.8,12.22 10.72,12.335 10.57,12.425 C10.42,12.51 10.21,12.555 9.95,12.555 C9.655,12.555 9.44,12.5 9.3,12.4 C9.145,12.285 9.05,12.09 9.01,11.82 L8.43,11.82 C8.455,12.275 8.62,12.605 8.92,12.815 C9.165,12.985 9.51,13.07 9.95,13.07 Z",
    id: "XLS",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9990397,4 L12,4 C11.4477153,4 11,3.55228475 11,3 L11,0 L11,0 L14.9990397,4 Z",
    id: "\u77E9\u5F62\u5907\u4EFD-11",
    fill: "#A6EED0"
  })))));
};
var _default = XlsIcon;
exports["default"] = _default;